"use strict";Object.defineProperty(exports,"__esModule",{value:!0});var createSizes=function(options){var _options$small=options.small,small=_options$small===void 0?24:_options$small,_options$medium=options.medium,medium=_options$medium===void 0?32:_options$medium,_options$large=options.large,large=_options$large===void 0?44:_options$large;return{small:small,medium:medium,large:large}};exports.default=createSizes;


/** WEBPACK FOOTER **
 ** ./~/@vitalsource/vstui/themes/createSizes.js
 **/